import API from "../../api/api.js";

const AccountRecoveryService = {
  verifyIr: async (data) => {
    return API.post("account-recovery/verify-ir", JSON.stringify(data))
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  saveIdentity: async (data) => {
    return API.post("account-recovery/identity", JSON.stringify(data))
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  getDocumentTypes: async () => {
    return API.get("account-recovery/document-types")
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  uploadDocuments: async (formData) => {
    return API.post("account-recovery/documents", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  sendOtp: async (data) => {
    return API.post("account-recovery/send-otp", JSON.stringify(data))
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  resendOtp: async (data) => {
    return API.post("account-recovery/resend-otp", JSON.stringify(data))
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  verifyOtp: async (data) => {
    return API.post("account-recovery/verify-otp", JSON.stringify(data))
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  submitRequest: async (data) => {
    return API.post("account-recovery/submit", JSON.stringify(data))
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  getStatus: async (token) => {
    return API.get(`account-recovery/status?token=${token}`)
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  verifyResetToken: async (data) => {
    return API.post("account-recovery/reset/verify", JSON.stringify(data))
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  setAccountPassword: async (data) => {
    return API.post(
      "account-recovery/reset/account-password",
      JSON.stringify(data)
    )
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
  setWalletPassword: async (data) => {
    return API.post(
      "account-recovery/reset/wallet-password",
      JSON.stringify(data)
    )
      .then((r) => r.data)
      .catch((e) => Promise.reject(e));
  },
};

export default AccountRecoveryService;
